var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState } from 'react';
import './ratingNotification.scss';
import { UuiFlexlayout } from '@aonunited/react';
import { GetRowHeight, columns } from './ColumnHeader/columnHeader';
import RatingsFilterPannel from './filterPannel/ratingsFilterPannel';
import { getResearchAndNotification, submitNotificationAlert } from '../../api/researchAndNotification';
import { useAppInfoStore } from '../../store';
import { observer } from 'mobx-react';
import AonAgGridTable from '../../components/core/AonAgGridTable/table';
var RatingAndNotification = (observer(function () {
    var appInfo = useAppInfoStore();
    var _a = React.useState({
        searchText: "",
        sortColumn: "IsUserSubscribedForRN",
        sortBy: "ASC"
    }), pageConfig = _a[0], setPageConfig = _a[1];
    var _b = useState(false), isLoading = _b[0], setIsLoading = _b[1];
    var _c = useState([]), ratingAndNotificationData = _c[0], setRatingAndNotificationData = _c[1];
    useEffect(function () {
        fetchdata(true);
    }, [appInfo.IEContactID]);
    var fetchdata = function () {
        var args_1 = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args_1[_i] = arguments[_i];
        }
        return __awaiter(void 0, __spreadArray([], args_1, true), void 0, function (isRefress, searchText) {
            var id, params, response, sortData, error_1;
            if (isRefress === void 0) { isRefress = false; }
            if (searchText === void 0) { searchText = ""; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setIsLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, 5, 6]);
                        id = appInfo.IEContactID;
                        if (!id) return [3 /*break*/, 3];
                        params = { ieContactID: id };
                        isRefress ? params["ratingSubscriptions"] = true : null;
                        searchText ? params["companyName"] = searchText : pageConfig.searchText ? params["companyName"] = pageConfig.searchText : null;
                        return [4 /*yield*/, getResearchAndNotification(params)];
                    case 2:
                        response = _a.sent();
                        sortData = response.data.sort(function (a, b) {
                            if (a.CompanyName > b.CompanyName) {
                                return +1;
                            }
                            else if (a.CompanyName < b.CompanyName) {
                                return -1;
                            }
                            else
                                return 0;
                        });
                        setRatingAndNotificationData(sortData);
                        _a.label = 3;
                    case 3: return [3 /*break*/, 6];
                    case 4:
                        error_1 = _a.sent();
                        console.log(error_1);
                        return [3 /*break*/, 6];
                    case 5:
                        setIsLoading(false);
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    var onRowClick = function (event, rowNumber) { return __awaiter(void 0, void 0, void 0, function () {
        var tempData, data, checked, request, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event.preventDefault();
                    tempData = __spreadArray([], ratingAndNotificationData, true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    tempData[rowNumber].isLoading = true;
                    data = tempData[rowNumber];
                    checked = !data.IsUserSubscribedForRN;
                    request = [{ Subscribe: checked, InsuranceEntityId: data.InsuranceEntityId }];
                    return [4 /*yield*/, submitNotificationAlert(request)];
                case 2:
                    _a.sent();
                    tempData[rowNumber].IsUserSubscribedForRN = checked;
                    setRatingAndNotificationData(__spreadArray([], tempData, true));
                    tempData[rowNumber].isLoading = false;
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    tempData[rowNumber].isLoading = false;
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var onHeaderClick = function (headerKey) {
        var revertSortBy = function (sBy) { return sBy === "DESC" ? "ASC" : "DESC"; };
        var tempData = __spreadArray([], ratingAndNotificationData, true);
        var reverseSort = revertSortBy(pageConfig.sortBy);
        tempData = tempData.sort(function (a, b) {
            if (a[headerKey] < b[headerKey]) {
                return reverseSort === "ASC" ? -1 : +1;
            }
            else if (a[headerKey] > b[headerKey]) {
                return reverseSort === "ASC" ? +1 : -1;
            }
            else
                return 0;
        });
        setRatingAndNotificationData(__spreadArray([], tempData, true));
        setPageConfig((function (prev) { return (__assign(__assign({}, prev), { sortBy: reverseSort, sortColumn: headerKey })); }));
    };
    var _d = useState(window.innerHeight), currentInneHeight = _d[0], setcurrentInneHeight = _d[1];
    useEffect(function () {
        var updateSize = function () {
            var innerHeight = window.innerHeight;
            setcurrentInneHeight(innerHeight);
        };
        window.addEventListener("resize", updateSize);
        var InputListner = function (Event) {
            if (Event.key === "Enter" && Event.target.value) {
                fetchdata(false, Event.target.value);
                Event === null || Event === void 0 ? void 0 : Event.preventDefault();
            }
        };
        var inputRef = document.getElementById("__marketNewsSearchInput__");
        if (inputRef) {
            inputRef.addEventListener("keydown", InputListner);
        }
        return function () {
            window.removeEventListener("resize", updateSize);
            inputRef.removeEventListener("keydown", InputListner);
        };
    }, []);
    return (React.createElement(UuiFlexlayout, { direction: 'column', className: 'ratings-outer-container' },
        React.createElement("div", { className: 'ratings-title' }, "RATINGS NOTIFICATION SERVICE"),
        React.createElement(RatingsFilterPannel, { onClickClear: function () { return fetchdata(true); }, onClickSearch: function (text) { return fetchdata(false, text); } }),
        React.createElement(AonAgGridTable, { columns: columns(onHeaderClick, pageConfig.sortColumn, pageConfig.sortBy, isLoading, onRowClick), rowData: ratingAndNotificationData, loading: isLoading, height: currentInneHeight, RowHeightCallback: GetRowHeight, suppressScrollOnNewData: true })));
}));
export default RatingAndNotification;
